<template>
  <div class="ranking-page mt-4">
    <app-page-header title="Ranking"></app-page-header>

    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <h2>Loja</h2>
          <div class="table">
            <div class="table-headers">
              <div class="table-header">Posição</div>
              <div class="table-header">Pontos</div>
            </div>
            <div class="table-rows">
              <div
                class="table-row current"
                v-if="showCurrent(storeRanking[0])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>1º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    storeRanking[0] !== undefined ? storeRanking[0].points : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(storeRanking[0])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <span>1º</span>
                </div>
                <div class="table-column">
                  {{
                    storeRanking[0] !== undefined ? storeRanking[0].points : '0'
                  }}
                </div>
              </div>
              <div
                class="table-row current"
                v-if="showCurrent(storeRanking[1])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>2º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    storeRanking[1] !== undefined ? storeRanking[1].points : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(storeRanking[1])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <span>2º</span>
                </div>
                <div class="table-column">
                  {{
                    storeRanking[1] !== undefined ? storeRanking[1].points : '0'
                  }}
                </div>
              </div>

              <div
                class="table-row current"
                v-if="showCurrent(storeRanking[2])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>3º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    storeRanking[2] !== undefined ? storeRanking[2].points : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(storeRanking[2])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <span>3º</span>
                </div>
                <div class="table-column">
                  {{
                    storeRanking[2] !== undefined ? storeRanking[2].points : '0'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-6 resale">
          <h2>Revenda</h2>
          <div class="table">
            <div class="table-headers">
              <div class="table-header">Posição</div>
              <div class="table-header">Pontos</div>
            </div>
            <div class="table-rows">
              <div
                class="table-row current"
                v-if="showCurrent(resaleRanking[0])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>1º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    resaleRanking[0] !== undefined
                      ? resaleRanking[0].points
                      : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(resaleRanking[0])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <span>1º</span>
                </div>
                <div class="table-column">
                  {{
                    resaleRanking[0] !== undefined
                      ? resaleRanking[0].points
                      : '0'
                  }}
                </div>
              </div>

              <div
                class="table-row current"
                v-if="showCurrent(resaleRanking[1])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>2º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    resaleRanking[1] !== undefined
                      ? resaleRanking[1].points
                      : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(resaleRanking[1])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <span>2º</span>
                </div>
                <div class="table-column">
                  {{
                    resaleRanking[1] !== undefined
                      ? resaleRanking[1].points
                      : '0'
                  }}
                </div>
              </div>

              <div
                class="table-row current"
                v-if="showCurrent(resaleRanking[2])"
              >
                <div class="table-column">
                  <div class="current__item">
                    <p>SUA POSIÇÃO</p>
                    <div>
                      <span>3º</span>
                    </div>
                  </div>
                </div>
                <div class="table-column points">
                  {{
                    resaleRanking[2] !== undefined
                      ? resaleRanking[2].points
                      : '0'
                  }}
                </div>
              </div>

              <div class="table-row" v-if="!showCurrent(resaleRanking[2])">
                <div class="table-column">
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <b-icon icon="star-outline" class="icon" />
                  <span>3º</span>
                </div>
                <div class="table-column">
                  {{
                    resaleRanking[2] !== undefined
                      ? resaleRanking[2].points
                      : '0'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RankingService from '@/services/ranking.service.js';

export default {
  name: 'ranking-page',
  data() {
    return {
      storeRanking: [],
      resaleRanking: [],
    };
  },
  methods: {
    load() {
      RankingService.get().then(({ data }) => {
        this.storeRanking = data.ranking_loja;
        this.resaleRanking = data.ranking_revenda;
      });
    },
    showCurrent(obj) {
      return obj !== undefined ? obj.current : false;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.container {
  .row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

h2 {
  text-align: center;
  font-weight: bold;
  font-size: 1.7em;
  margin-bottom: 1em;
}

.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  font-size: 1.1em;
}

.table-headers {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: var(--color-secondary);
  color: #fff;
  border-radius: 8px;
  padding: 1em;
  text-transform: uppercase;
}

.table-rows {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.table-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 1em;
  border-radius: 8px;

  &:nth-child(even):not(.current) {
    background: var(--color-light-grey);
  }
}

.current {
  background: var(--color-dark-grey);

  &__item {
    display: flex;
    align-items: center;

    p {
      font-size: 0.8em;
      font-weight: bolder;
      color: #fff;
    }

    div {
      position: relative;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background-color: #fff;
      text-align: center;
      margin-left: 20px;

      span {
        font-size: 1.2em;
        font-weight: bolder;
        margin: 0;
        color: var(--color-primary);
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .table-column {
    &:last-child {
      font-weight: bold;
      color: #fff;
    }
  }
}

.table-column {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin-left: 0.75em;
    color: var(--text-color-light);
  }

  .icon {
    color: var(--color-secondary);
  }

  &:last-child {
    font-weight: bold;
    color: var(--color-primary);
  }
}

table {
  border-radius: 8px;
  display: block;

  th {
    color: #fff;
    text-transform: uppercase;
    background: var(--color-secondary);
  }

  tr {
    &:nth-child(odd) {
      td {
        background: var(--color-light-grey);
      }
    }
  }
  th,
  td {
    padding: 1em;

    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
  }
}

@media (max-width: 992px) {
  .resale h2 {
    margin-top: 2em;
  }
}
</style>
